import React from "react";
import FlatpickrComponent from "react-flatpickr";
import { useTranslation } from "react-i18next";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

type FlatpickrProps = React.ComponentProps<typeof FlatpickrComponent>;
type FlatpickrInstance = React.ElementRef<typeof FlatpickrComponent>;

/** Customized Flatpickr component; use this in place of react-flatpickr */
const Flatpickr = React.forwardRef<FlatpickrInstance, FlatpickrProps>(
  (props, ref) => {
    const { i18n } = useTranslation();

    return (
      <FlatpickrComponent
        {...props}
        options={{
          locale: i18n.language === "ja" ? Japanese : "en",
          time_24hr: true,
          ...props.options,
        }}
        ref={ref}
      />
    );
  },
);

export type { FlatpickrProps };
export default Flatpickr;
